import { defineComponent as _defineComponent } from 'vue'
import { listaDeGraus } from '@/../common/shareds/sharedsIrmao'

export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorDeGrauDoMacon',
  setup(__props) {


return { __sfc: true,listaDeGraus }
}

})